export default class Money {

    static toData(money) {
        if(null === money) {
            return null;
        }
        return {
            amount: money.amount,
            currency: money.currency,
        }
    }
    static fromData(data) {
        let money = new Money();
        money.config = this.config.hasOwnProperty(data.currency) ? this.config[data.currency] : this.config.default;
        money.amount = data.amount;
        money.currency = data.currency;
        Object.seal(money);
        return money;
    }

    static fromNumber(number, currency) {

        if(number === '' || number === null) {
            return null;
        }
        let money = new Money();
        money.config = this.config.hasOwnProperty(currency) ? this.config[currency] : this.config.default;
        money.amount = {
            denominator: Math.pow(10, money.config.decimalPlaces)
        }
        money.amount.numerator = Math.round(number * money.amount.denominator);
        money.currency = currency;

        Object.seal(money);
        return money;
    }

    toNumber() {
        return parseFloat((this.amount.numerator / this.amount.denominator).toFixed(this.config.decimalPlaces));
    }

    toLocalizedString() {
        return this.toNumber().toFixed(this.config.decimalPlaces).toString().replace('.', this.config.decimalSeparator);
    }

    format() {
        return this.toLocalizedString() + ' ' + this.currency;
    }

    static fromLocalizedString(localizedString, currency) {
        let config = this.config.hasOwnProperty(currency) ? this.config[currency] : this.config.default;
        return this.fromNumber(parseFloat(localizedString.replace(config.decimalSeparator, '.')), currency);
    }

    static isValidLocalizedString(localizedString, currency) {
        let config = this.config.hasOwnProperty(currency) ? this.config[currency] : this.config.default;
        let regexString = '^[0-9]\\d*(?:' + config.decimalSeparator + '\\d{0,' + config.decimalPlaces + '})?$';
        let regex = RegExp(regexString);
        let valid = regex.test(localizedString);

        return valid;
    }
}

Money.config = {
    default: {decimalPlaces: 2, decimalSeparator: ','},
    EUR: {decimalPlaces: 2, decimalSeparator: ','}
}
